import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../App';
import './Header.css'
const Header = () => {
  
    return (
      
   <nav className="navbar navbar-expand-lg navbar-light bg-light navbar-style">
  <div className="container-fluid">
    <a className="navbar-brand" href="#">Navbar</a>
    
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse " id="navbarNav">
      <ul className="navbar-nav ml-lg-auto nav-iteam">
        <li className="nav-item">
        <Link className="nav-link active" aria-current="page" to="/home"> Home </Link>
        </li>
        <li className="nav-item">
        <Link className="nav-link active" aria-current="page" to="/order"> Order </Link>
        </li>
        <li className="nav-item">
        <Link className="nav-link active" aria-current="page" to="/admin"> Admin </Link>
        </li>
        <li className="nav-item">
        <Link className="nav-link active" aria-current="page" to="/deals"> Deals </Link>
        </li>
        <li className="nav-item">
        <Link className="nav-link active" aria-current="page" className="btn btn-warning" to="/login"> Login </Link>
        </li>
      </ul>
    </div>
  </div>
</nav>
        
    );
};

export default Header;